export default __webpack_public_path__ + "static/media/ecom2.97f03030.png";